import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './PharmacyProfile.css';
import Sidebar from '../Sidebar/Sidebar';
import {
  FaStore,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaCheckCircle,
  FaCalendarAlt,
  FaCity,
  FaEnvelope,
  FaEdit,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const PharmacyProfile = () => {
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');
  const [logoVersion, setLogoVersion] = useState(Date.now());
  const token = localStorage.getItem('access_token');
  const navigate = useNavigate();

  const fetchProfile = async () => {
    try {
      const res = await axios.get('http://127.0.0.1:8000/users/users/profile', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProfile(res.data.profile);
    } catch (err) {
      setError('Failed to load profile.');
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleVerificationRequest = () => {
    navigate('/PharmacyVerificationForm');
  };

  const handleUpdateProfile = () => {
    navigate('/UpdatePharmacyProfile');
  };

  const handleLogoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('logo', file);

    try {
      await axios.put('http://127.0.0.1:8000/users/pharmacy/logo', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('Logo updated!');
      setLogoVersion(Date.now());
      fetchProfile();
    } catch (error) {
      console.error(error);
      alert('Failed to update logo.');
    }
  };

  if (error) return <div className="error-message">{error}</div>;
  if (!profile) return <div>Loading profile...</div>;

  const logoUrl =
    (profile.logo && `${profile.logo}?v=${logoVersion}`) ||
    `http://127.0.0.1:8000/static/images/profile.png?v=${logoVersion}`;

  const statusClass = {
    VERIFIED: 'verified-status',
    REJECTED: 'rejected-status',
    PENDING: 'pending-status',
    NOT_APPLIED: 'not-applied-status',
  }[profile.verification_status];

  const shouldShowVerificationBtn =
    profile.verification_status === 'NOT_APPLIED' || profile.verification_status === 'REJECTED';

  return (
    <div className="profile-layout">
      {/* Sidebar visible only on desktop */}
      <div className="sidebar-container">
        <Sidebar />
      </div>

      {/* Profile Content */}
      <div className="profile-main">
        <div className="profile-card">
          <img src={logoUrl} alt="Pharmacy Logo" className="pharmacy-logo" />

          <input
            type="file"
            accept="image/*"
            onChange={handleLogoChange}
            style={{ marginTop: '10px', marginBottom: '20px' }}
          />

          <h3>
            <FaStore /> {profile.pharmacy_name}{' '}
            {profile.verification_status === 'VERIFIED' && (
              <FaCheckCircle className="verified-icon" title="Verified Pharmacy" />
            )}
          </h3>
          <p>
            <FaMapMarkerAlt /> Address: {profile.pharmacy_address}
          </p>
          <p>
            <FaCity /> City: {profile.city || 'N/A'}
          </p>
          <p>
            <FaPhoneAlt /> Phone: {profile.phone_number}
          </p>
          <p>
            <FaEnvelope /> Email: {profile.email || 'N/A'}
          </p>
          <p>
            Verification Status:{' '}
            <strong className={statusClass}>{profile.verification_status}</strong>
          </p>
          <p>
            <FaCalendarAlt /> Created:{' '}
            {new Date(profile.created_at).toLocaleDateString()}
          </p>

          {shouldShowVerificationBtn && (
            <button className="verification-btn" onClick={handleVerificationRequest}>
              Submit Verification Request
            </button>
          )}

          <button className="update-profile-btn" onClick={handleUpdateProfile}>
            <FaEdit style={{ marginRight: '5px' }} />
            Update Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default PharmacyProfile;
